import { Plugin } from '@ckeditor/ckeditor5-core';
import { ButtonView } from '@ckeditor/ckeditor5-ui';
import ImageBrowserUI from './image-browser-ui';

export default class ImageBrowser extends Plugin {
    static get requires() {
        return [ImageBrowserUI];
    }

    static get pluginName() {
        return 'ImageBrowser';
    }
}
